// Backend
import React from 'react';

// Frontend
import { Grid, Cell } from 'react-foundation';

// Functionality
import { useParams, useLocation, Link } from 'react-router-dom';

// Components
import {
  Header,
  FlashMessage,
  ProgressBar,
  ErrorRender,
} from '../../constants/SharedComponents';
import { useDemoContext } from '../../contexts/DemoContext';

export function DemoConversationsShow() {
  // Params
  const { conversationId } = useParams();

  // Demo context
  const { nextDemoStep } = useDemoContext();
  const { state } = useLocation();

  // Objects - simulating production structure
  const [flashMessageObject, setFlashMessageObject] = React.useState({});
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error] = React.useState(null);

  // Demo data - using role information from navigation state if available
  const isUserManager = state?.isUserManager || false;
  const demoData = {
    id: conversationId,
    isUserManager: isUserManager, // Use the actual role from conversation creation
    isOrganiserManager: isUserManager, // In demo, manager is always the organiser
    attendeeName: 'Jane Smith',
    organiserName: 'Demo User',
  };

  // Functions
  React.useEffect(() => {
    // Simulate loading
    setTimeout(() => {
      setData(demoData);
      setLoading(false);
    }, 500);

    if (state?.flashMessage) {
      setFlashMessageObject(state.flashMessage);
    }
  }, [state]);

  return (
    <>
      <ProgressBar loading={loading} />
      <Header />
      <FlashMessage object={flashMessageObject} columnWrap={true} />
      <ErrorRender object={error} />

      {data && (
        <div className="grid-container">
          <Grid className="grid-padding-x align-justify">
            <Cell small={12}>
              <div className="page-content">
                <div className="page-content__header">
                  <Link
                    to="/demo/conversations"
                    className="page-content__button--medium page-content__button--back"
                    id="page-navigation-button--go-back"
                  >
                    Go back
                  </Link>
                </div>

                <h1 className="page-content__title">Conversation</h1>

                {!data.isUserManager && (
                  <>
                    <p>You can begin conversation preparation.</p>

                    <Link
                      to={`/demo/conversations/${data.id}/team-member-prep/new`}
                      className="page-content__button--medium"
                      id="page-navigation-button--start"
                      onClick={() => nextDemoStep()}
                    >
                      Start
                    </Link>
                  </>
                )}

                {data.isUserManager && (
                  <>
                    <p>The conversation has been created.</p>

                    <p>
                      {data.isOrganiserManager ? data.attendeeName : data.organiserName} has been
                      notified and will be invited to either register on the system if they are a
                      first time user, or to log onto their dashboard and undertake the
                      preparation for this meeting.
                    </p>

                    <p>
                      Remember in your capacity as a manager our Forward Together platform will notify
                      you of the conversation topics{' '}
                      {data.isOrganiserManager ? data.attendeeName : data.organiserName} would
                      like to discuss.
                    </p>

                    <div className="demo-notice">
                      <p>
                        <strong>Demo:</strong> As a manager, you'll be notified when the team member completes their preparation.
                      </p>
                    </div>
                  </>
                )}
              </div>
            </Cell>
          </Grid>
        </div>
      )}
    </>
  );
}
